<script>
  import Header from "../components/Header.svelte";
  import Footer from "../components/Footer.svelte";

  import { onDestroy } from "svelte";
  import textStore from "../stores/textStore.js";

  //Array of text objects to iterate over and display on pre navigation
  let data = [
    {
      text: "Webbutvecklare",
    },
    {
      text: "Knivmakare",
    },
    {
      text: "Konstnär",
    },
  ];

  var innerText = [{ text: "Webbutvecklare" }];
  //Subscribe to text store and redefine variable
  const unsubscribe = textStore.subscribe((current) => {
    innerText = current;
  });

  //Unsubscribe on component unmount
  onDestroy(unsubscribe);

  const timer = (ms) => new Promise((res) => setTimeout(res, ms));
  //Async function to set a timer of 3 seconds between each iteration
  async function load() {
    for (let i = 0; i <= data.length; i++) {
      await timer(3000);
      //Restarts loop
      if (i === data.length) {
        i = 0;
      }
      //Assigns the array loop to store variable
      innerText = data[i];
      textStore.update((current) => {
        return innerText;
      });
    }
  }
  //invoke the loop function
  load();
</script>

<!--Pre navigation header section-->
<header id="page-header">
  <div class="header-text-wrapper">
    <!--Oskar Ljung Logo SVG-->
    <svg
      width="347"
      height="63"
      viewBox="0 0 347 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Oskar Ljung">
        <path
          d="M40.3389 24.8789V26.9419C40.3389 30.4543 39.8522 33.6069 38.8789 36.3999C37.9268 39.1929 36.562 41.5732 34.7847 43.541C33.0285 45.5088 30.9338 47.0216 28.5005 48.0796C26.0884 49.1164 23.4118 49.6348 20.4707 49.6348C17.5296 49.6348 14.8424 49.1164 12.4092 48.0796C9.97591 47.0216 7.86003 45.5088 6.06152 43.541C4.28418 41.5732 2.90885 39.1929 1.93555 36.3999C0.96224 33.6069 0.475586 30.4543 0.475586 26.9419V24.8789C0.475586 21.3665 0.96224 18.2139 1.93555 15.4209C2.90885 12.6068 4.2736 10.2158 6.02979 8.24805C7.80713 6.28027 9.91243 4.77799 12.3457 3.74121C14.779 2.68327 17.4661 2.1543 20.4072 2.1543C23.3483 2.1543 26.0355 2.68327 28.4688 3.74121C30.902 4.77799 32.9967 6.28027 34.7529 8.24805C36.5303 10.2158 37.9056 12.6068 38.8789 15.4209C39.8522 18.2139 40.3389 21.3665 40.3389 24.8789ZM29.897 26.9419V24.8154C29.897 22.4668 29.6854 20.3932 29.2622 18.5947C28.839 16.7751 28.2254 15.2516 27.4214 14.0244C26.6174 12.7972 25.6229 11.8768 24.438 11.2632C23.2531 10.6284 21.9095 10.311 20.4072 10.311C18.8415 10.311 17.4767 10.6284 16.313 11.2632C15.1493 11.8768 14.1654 12.7972 13.3613 14.0244C12.5785 15.2516 11.9754 16.7751 11.5522 18.5947C11.1502 20.3932 10.9492 22.4668 10.9492 24.8154V26.9419C10.9492 29.2694 11.1502 31.3429 11.5522 33.1626C11.9754 34.9611 12.589 36.4845 13.3931 37.7329C14.1971 38.9813 15.181 39.9229 16.3447 40.5576C17.5296 41.1924 18.9049 41.5098 20.4707 41.5098C21.973 41.5098 23.306 41.1924 24.4697 40.5576C25.6546 39.9229 26.6491 38.9813 27.4531 37.7329C28.2572 36.4845 28.8602 34.9611 29.2622 33.1626C29.6854 31.3429 29.897 29.2694 29.897 26.9419ZM220.485 41.002V49H197.158V41.002H220.485ZM200.681 2.78906V49H190.334V2.78906H200.681Z"
          fill="#CE3D57"
        />
        <path
          d="M64.46 39.4468C64.46 38.812 64.259 38.2513 63.8569 37.7646C63.4761 37.278 62.7778 36.8337 61.7622 36.4316C60.7677 36.0296 59.3607 35.6276 57.541 35.2256C55.8271 34.8659 54.2297 34.4004 52.7485 33.8291C51.2674 33.2367 49.9767 32.5278 48.8765 31.7026C47.7762 30.8563 46.9193 29.8618 46.3057 28.7192C45.6921 27.5555 45.3853 26.2331 45.3853 24.752C45.3853 23.3132 45.6921 21.9484 46.3057 20.6577C46.9404 19.367 47.8503 18.2244 49.0352 17.23C50.2412 16.2355 51.7012 15.4526 53.415 14.8813C55.1501 14.3101 57.1178 14.0244 59.3184 14.0244C62.3441 14.0244 64.9572 14.5005 67.1577 15.4526C69.3582 16.3836 71.0509 17.6955 72.2358 19.3882C73.4207 21.0597 74.0132 22.9746 74.0132 25.1328H64.1108C64.1108 24.2441 63.9416 23.4718 63.603 22.8159C63.2645 22.16 62.7461 21.6522 62.0479 21.2925C61.3496 20.9116 60.4292 20.7212 59.2866 20.7212C58.3979 20.7212 57.6151 20.8799 56.938 21.1973C56.2821 21.4935 55.7637 21.9061 55.3828 22.4351C55.0231 22.964 54.8433 23.5776 54.8433 24.2759C54.8433 24.7625 54.9491 25.2069 55.1606 25.6089C55.3934 25.9897 55.7425 26.3494 56.208 26.688C56.6947 27.0054 57.3188 27.291 58.0806 27.5449C58.8634 27.7988 59.8156 28.0422 60.937 28.2749C63.328 28.7192 65.5073 29.3434 67.4751 30.1475C69.464 30.9515 71.0509 32.0623 72.2358 33.48C73.4419 34.8976 74.0449 36.7702 74.0449 39.0977C74.0449 40.6211 73.6958 42.0176 72.9976 43.2871C72.3205 44.5566 71.3366 45.6675 70.0459 46.6196C68.7552 47.5718 67.2106 48.3123 65.4121 48.8413C63.6136 49.3703 61.5824 49.6348 59.3184 49.6348C56.0811 49.6348 53.341 49.0529 51.0981 47.8892C48.8553 46.7254 47.1626 45.2655 46.02 43.5093C44.8986 41.7319 44.3379 39.9123 44.3379 38.0503H53.6372C53.6795 39.1929 53.9652 40.1239 54.4941 40.8433C55.0443 41.5627 55.7531 42.0916 56.6206 42.4302C57.4881 42.7476 58.4614 42.9062 59.5405 42.9062C60.6196 42.9062 61.5189 42.7581 62.2383 42.4619C62.9577 42.1657 63.5078 41.7637 63.8887 41.2559C64.2695 40.7269 64.46 40.1239 64.46 39.4468ZM89.5332 0.218262V49H79.5991V0.218262H89.5332ZM111.337 14.6592L96.3887 31.9248L88.4858 39.8594L84.5186 33.1626L90.9297 24.8789L99.4038 14.6592H111.337ZM100.864 49L91.1836 33.2261L98.293 27.6719L112.226 49H100.864ZM132.919 40.8115V26.085C132.919 25.0482 132.761 24.1595 132.443 23.4189C132.126 22.6784 131.629 22.0965 130.952 21.6733C130.275 21.2502 129.396 21.0386 128.317 21.0386C127.408 21.0386 126.614 21.1973 125.937 21.5146C125.281 21.832 124.773 22.2869 124.414 22.8794C124.075 23.4718 123.906 24.2018 123.906 25.0693H114.003C114.003 23.5247 114.353 22.0859 115.051 20.7529C115.749 19.4199 116.743 18.2456 118.034 17.23C119.346 16.2144 120.912 15.4315 122.731 14.8813C124.551 14.3101 126.593 14.0244 128.857 14.0244C131.544 14.0244 133.935 14.4793 136.03 15.3892C138.146 16.2778 139.817 17.6214 141.044 19.4199C142.272 21.1973 142.885 23.4401 142.885 26.1484V40.5259C142.885 42.5994 143.002 44.2287 143.234 45.4136C143.488 46.5773 143.848 47.5929 144.313 48.4604V49H134.316C133.85 48.0055 133.501 46.7783 133.269 45.3184C133.036 43.8372 132.919 42.335 132.919 40.8115ZM134.157 28.0527L134.221 33.5117H129.301C128.201 33.5117 127.249 33.6493 126.445 33.9243C125.662 34.1994 125.027 34.5802 124.541 35.0669C124.054 35.5324 123.694 36.0825 123.461 36.7173C123.25 37.3309 123.144 38.008 123.144 38.7485C123.144 39.4468 123.313 40.0815 123.652 40.6528C123.99 41.203 124.456 41.6367 125.048 41.9541C125.641 42.2715 126.328 42.4302 127.111 42.4302C128.402 42.4302 129.502 42.1763 130.412 41.6685C131.343 41.1606 132.062 40.547 132.57 39.8276C133.078 39.0871 133.332 38.3994 133.332 37.7646L135.712 41.8906C135.332 42.737 134.866 43.6151 134.316 44.5249C133.766 45.4136 133.068 46.2493 132.221 47.0322C131.375 47.7939 130.349 48.4181 129.143 48.9048C127.958 49.3914 126.529 49.6348 124.858 49.6348C122.7 49.6348 120.743 49.201 118.986 48.3335C117.23 47.4448 115.823 46.2282 114.765 44.6836C113.728 43.139 113.21 41.3617 113.21 39.3516C113.21 37.5531 113.538 35.9556 114.194 34.5591C114.85 33.1626 115.834 31.9777 117.146 31.0044C118.479 30.0311 120.15 29.3011 122.16 28.8145C124.17 28.3066 126.519 28.0527 129.206 28.0527H134.157ZM159.326 22.6572V49H149.423V14.6592H158.723L159.326 22.6572ZM169.577 14.4053L169.418 23.6411C168.995 23.5776 168.445 23.5247 167.768 23.4824C167.091 23.4189 166.509 23.3872 166.022 23.3872C164.753 23.3872 163.653 23.5459 162.722 23.8633C161.812 24.1595 161.05 24.6038 160.437 25.1963C159.844 25.7887 159.4 26.5293 159.104 27.418C158.807 28.2855 158.659 29.2905 158.659 30.4331L156.787 29.5127C156.787 27.2487 157.009 25.1751 157.453 23.292C157.897 21.4089 158.543 19.7796 159.389 18.4043C160.236 17.0078 161.272 15.9287 162.5 15.167C163.727 14.4053 165.123 14.0244 166.689 14.0244C167.197 14.0244 167.715 14.0562 168.244 14.1196C168.773 14.1831 169.217 14.2783 169.577 14.4053ZM225.69 14.6592H235.656V50.5869C235.656 53.2318 235.159 55.464 234.165 57.2837C233.17 59.1245 231.731 60.5104 229.848 61.4414C227.986 62.3936 225.754 62.8696 223.151 62.8696C222.305 62.8696 221.501 62.8273 220.739 62.7427C219.978 62.6792 219.163 62.5417 218.295 62.3301V54.7764C218.824 54.861 219.332 54.9245 219.819 54.9668C220.284 55.0303 220.782 55.062 221.311 55.062C222.263 55.062 223.056 54.9033 223.691 54.5859C224.347 54.2686 224.844 53.7713 225.183 53.0942C225.521 52.4383 225.69 51.6025 225.69 50.5869V14.6592ZM224.929 5.77246C224.929 4.33366 225.437 3.15934 226.452 2.24951C227.468 1.31852 228.811 0.853027 230.483 0.853027C232.133 0.853027 233.466 1.31852 234.482 2.24951C235.498 3.15934 236.005 4.33366 236.005 5.77246C236.005 7.1901 235.498 8.36442 234.482 9.29541C233.466 10.2052 232.133 10.6602 230.483 10.6602C228.811 10.6602 227.468 10.2052 226.452 9.29541C225.437 8.36442 224.929 7.1901 224.929 5.77246ZM262.475 40.7163V14.6592H272.441V49H263.11L262.475 40.7163ZM263.522 33.7021L266.252 33.6387C266.252 35.945 265.977 38.0715 265.427 40.0181C264.898 41.9647 264.094 43.6574 263.015 45.0962C261.957 46.535 260.634 47.6564 259.047 48.4604C257.482 49.2433 255.651 49.6348 253.557 49.6348C251.864 49.6348 250.309 49.402 248.891 48.9365C247.495 48.4499 246.289 47.6987 245.273 46.6831C244.257 45.6463 243.474 44.3239 242.924 42.7158C242.374 41.0866 242.099 39.14 242.099 36.876V14.6592H252.001V36.9395C252.001 37.8281 252.107 38.5898 252.319 39.2246C252.552 39.8382 252.858 40.346 253.239 40.748C253.641 41.1501 254.128 41.4463 254.699 41.6367C255.292 41.8271 255.937 41.9224 256.635 41.9224C258.391 41.9224 259.767 41.5627 260.761 40.8433C261.777 40.1027 262.486 39.1188 262.888 37.8916C263.311 36.6432 263.522 35.2467 263.522 33.7021ZM288.596 21.9907V49H278.662V14.6592H287.993L288.596 21.9907ZM287.294 30.6235L284.819 30.687C284.819 28.1056 285.136 25.7887 285.771 23.7363C286.406 21.6839 287.305 19.9383 288.469 18.4995C289.654 17.0396 291.061 15.9287 292.69 15.167C294.34 14.4053 296.16 14.0244 298.149 14.0244C299.757 14.0244 301.228 14.2572 302.561 14.7227C303.894 15.1882 305.036 15.9393 305.988 16.9761C306.962 17.9917 307.702 19.3459 308.21 21.0386C308.718 22.7101 308.972 24.7731 308.972 27.2275V49H299.006V27.1958C299.006 25.757 298.805 24.6462 298.403 23.8633C298.001 23.0804 297.408 22.5303 296.625 22.2129C295.864 21.8955 294.933 21.7368 293.833 21.7368C292.669 21.7368 291.674 21.9696 290.849 22.4351C290.024 22.8794 289.347 23.5036 288.818 24.3076C288.289 25.1117 287.897 26.0532 287.644 27.1323C287.411 28.2114 287.294 29.3752 287.294 30.6235ZM337.092 14.6592H346.105V47.7622C346.105 50.9149 345.386 53.5915 343.947 55.792C342.53 57.9925 340.551 59.6641 338.012 60.8066C335.473 61.9492 332.5 62.5205 329.094 62.5205C327.613 62.5205 326.068 62.3195 324.46 61.9175C322.852 61.5366 321.339 60.9548 319.921 60.1719C318.504 59.4102 317.319 58.4368 316.367 57.252L320.588 51.4121C321.561 52.5124 322.725 53.401 324.079 54.0781C325.433 54.7764 326.978 55.1255 328.713 55.1255C330.3 55.1255 331.643 54.8398 332.744 54.2686C333.844 53.6973 334.68 52.8615 335.251 51.7612C335.843 50.661 336.14 49.328 336.14 47.7622V22.689L337.092 14.6592ZM314.145 32.2422V31.5757C314.145 28.9731 314.462 26.6034 315.097 24.4663C315.732 22.3081 316.652 20.4567 317.858 18.9121C319.086 17.3464 320.556 16.1403 322.27 15.2939C324.005 14.4476 325.952 14.0244 328.11 14.0244C330.437 14.0244 332.363 14.4688 333.886 15.3574C335.41 16.2249 336.647 17.4521 337.6 19.0391C338.552 20.6048 339.303 22.4562 339.853 24.5933C340.403 26.7091 340.847 29.0049 341.186 31.4805V32.623C340.847 34.9928 340.361 37.2039 339.726 39.2563C339.091 41.3088 338.266 43.1178 337.25 44.6836C336.235 46.2282 334.965 47.4448 333.442 48.3335C331.94 49.201 330.141 49.6348 328.046 49.6348C325.909 49.6348 323.984 49.201 322.27 48.3335C320.556 47.466 319.086 46.2493 317.858 44.6836C316.652 43.1178 315.732 41.277 315.097 39.1611C314.462 37.0452 314.145 34.7389 314.145 32.2422ZM324.047 31.5757V32.2422C324.047 33.5964 324.174 34.8553 324.428 36.019C324.703 37.1828 325.105 38.209 325.634 39.0977C326.184 39.9863 326.861 40.6846 327.666 41.1924C328.491 41.679 329.453 41.9224 330.554 41.9224C332.162 41.9224 333.463 41.5838 334.458 40.9067C335.473 40.2085 336.214 39.2458 336.679 38.0186C337.166 36.7913 337.42 35.3631 337.441 33.7339V30.4014C337.441 29.0472 337.303 27.8306 337.028 26.7515C336.753 25.6724 336.341 24.7625 335.791 24.022C335.262 23.2814 334.563 22.7207 333.696 22.3398C332.849 21.9378 331.823 21.7368 330.617 21.7368C329.538 21.7368 328.586 21.9907 327.761 22.4985C326.936 22.9852 326.248 23.6729 325.698 24.5615C325.148 25.4502 324.735 26.4976 324.46 27.7036C324.185 28.8885 324.047 30.1792 324.047 31.5757Z"
          fill="#F3F3F3"
        />
      </g>
    </svg>
    <!--
			Easy text slider. 
			Before loop starts displays default Webbutvecklare
		-->
    <h2>
      <span class="red-cutof"
        >Hobby
      </span>{#if !innerText.text}Webbutvecklare{:else}{innerText.text}{/if}
    </h2>
  </div>
</header>
<!--Navigation header component-->
<Header />
<main>
  <section>
    <!--Biography Card-->
    <div class="card">
      <!--Quick bio block-->
      <div class="text-block">
        <h1>Jag heter Oskar Ljung</h1>
        <p>
          Min stora passion är Webbutveckling! Jag har varit data intresserad
          sedan jag var 12-13år gammal, alltid gillat att skapa saker både med
          händerna och hjärnan.
        </p>
        <p>
          Kluriga uppgifter driver mig och perfektion är ett måste! Jag gillar
          att utmana mig själv och är inte rädd för att lära mig nya saker
          “Kunskap och ambition är nyckeln till framgång”.
        </p>
        <p>
          Jag ligger gärna i framkant med insikt inom tech-världen då personlig
          utveckling är viktigt för mig.
        </p>
      </div>
      <!--Aside sloyd hobby block-->
      <div class="sloyd-block">
        <img src="./assets/frontpage/DSC_0176.jpg" alt="Kniv" />
        <a class="link" href="#/galleri">Slöjd</a>
        <p class="small-text">
          Jag ägnar mig även åt slöjd, mer exakt samisk slöjd. Detta har varit
          ett intresse för mig sedan länge, den första kniven gjorde jag
          tillsammans med min morfar vid 6 års ålder. Jag tog upp det som hobby
          i 20 års åldern.
        </p>
      </div>
    </div>
    <!--Projects Card-->
    <div class="card">
      <div class="site-wrapper">
        <!--Project site block-->
        <div class="site-container">
          <div class="left-site-block">
            <h2>Fishing-Sweden.se</h2>
            <p>
              Denna webbsidan har jag gjort åt min svärfar som hyr ut fisketurer
              och stugor. Den är byggd med "11ty" och har Netlify's CMS
              integrerat.
            </p>
            <!--Link to project website-->
            <a href="https://fishing-sweden.se/" target="_blank" class="link"
              >Länk</a
            >
          </div>
          <div class="right-site-block">
            <img
              src="/assets/frontpage/fishing-sweden.jpg"
              alt="Fishing-sweden screenshot"
            />
          </div>
        </div>

        <hr />

        <!--Project site block-->
        <div class="site-container">
          <div class="left-site-block">
            <h2>Ljungsan.com</h2>
            <p>
              Jag gjorde denna till min och min frus kennel. Webbsidan är byggd
              med Eleventy "11ty", en statisk sidgenerator.
            </p>
            <!--Link to project website-->
            <a href="https://ljungsan.com/" target="_blank" class="link">Länk</a
            >
          </div>
          <div class="right-site-block">
            <img
              src="/assets/frontpage/ljungsan.jpg"
              alt="Ljungsan screenshot"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<!--Footer component-->
<Footer />

<style>
  #page-header {
    background-image: url(https://images.pexels.com/photos/160107/pexels-photo-160107.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260);
    background-size: cover;
    background-position: center;
    height: 100vh;
    box-shadow: inset 50vw 0px 2000px 0px rgba(0, 0, 0, 0.6);
    z-index: -1;
    position: sticky;
    top: 0;
  }

  .red-cutof {
    color: #ce3d57;
  }

  .header-text-wrapper {
    text-align: center;
    font-size: 1.2rem;
    padding-top: 50vh;
    margin-left: 20%;
    width: max-content;
    color: #f3f3f3;
  }

  p {
    margin: 10px auto;
  }

  hr {
    width: 100%;
    margin: 20px auto;
    border: 1px solid #4a4a4a;
  }

  .small-text {
    color: #c7c7c7;
  }

  .card {
    display: flex;
    max-width: 960px;
    width: 100%;
    margin: auto;
    margin-top: 30px;
    border-radius: 15px;
    background-color: #353535;
    color: #f3f3f3;
    padding: 40px;
    gap: 30px;
  }

  .text-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    font-size: 18px;
  }

  .sloyd-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    max-width: 350px;
  }

  .sloyd-block img {
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.25);
    margin-bottom: 30px;
  }

  .site-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .site-container {
    display: flex;
    justify-content: space-between;
  }

  .left-site-block {
    text-align: left;
    max-width: 50ch;
  }

  .right-site-block img {
    filter: drop-shadow(10px 10px 10px rgba(0, 0, 0, 0.25));
  }

  .link {
    background-color: #ce3d57;
    color: #f3f3f3;
    text-decoration: none;
    font-size: 1.2rem;
    padding: 5px 40px;
    border-radius: 5px;
    filter: drop-shadow(10px 10px 10px rgba(0, 0, 0, 0.25));
  }

  .link:hover {
    background-color: #832a3a;
    transition: all 0.3s ease-in-out;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  @media (max-width: 600px) {
    .header-text-wrapper {
      width: 100%;
      text-align: center;
      margin-left: 0;
    }
  }

  @media (max-width: 400px) {
    .header-text-wrapper svg {
      width: 250px;
    }
  }

  @media (max-width: 800px) {
    .card {
      flex-direction: column;
      align-items: center;
      padding: 5%;
      border-radius: 0;
    }

    .site-container {
      flex-direction: column;
      margin: 30px 0;
    }

    .right-site-block img {
      margin-top: 30px;
    }

    main {
      padding: 0;
    }
  }
</style>
